// Lib
import React, { useState } from 'react';
import PropTypes from 'prop-types';

// Components
import PublishBoardPanel from '../popup/publish/PublishBoardPanel';
import BoardEditorPanel from '../popup/editing/BoardEditorPanel';
import ErrorToast from '../../../../../components/toast/ErrorToast';

const ShareModalContent = (props) => {
    const [errorToastMessage, setErrorToastMessage] = useState(null);

    return (
        <div className="ShareModalContent">
            <BoardEditorPanel {...props} setErrorToast={setErrorToastMessage} />
            <PublishBoardPanel {...props} setErrorToast={setErrorToastMessage} />
            <ErrorToast
                message={errorToastMessage}
                show={!!errorToastMessage}
                onDismiss={() => setErrorToastMessage(null)}
                groupId="ShareModal"
            />
        </div>
    );
};

ShareModalContent.propTypes = {
    mode: PropTypes.string,
};

export default ShareModalContent;
